import one from "../assets/profile.jpg";
import two from "../assets/profile2.jpg";
import three from "../assets/profile3.jpg";
import four from "../assets/profile4.jpg";
import five from "../assets/profile5.jpg";
import six from "../assets/profile6.jpg";

export const userProfileIMG = [
	{ id: 1, profile: one },
	{ id: 2, profile: two },
	{ id: 3, profile: three },
	{ id: 4, profile: four },
	{ id: 5, profile: five },
	{ id: 6, profile: six },
]